import { useEffect, useRef, useState, ReactNode } from 'react'

export default function useIntersect({
  rootMargin,
  threshold = 1,
  callback,
}: {
  rootMargin?: any
  threshold?: number[] | number
  callback?: () => void
}): {
  refItem: React.Dispatch<React.SetStateAction<ReactNode>>
  refRoot: React.MutableRefObject<any>
} {
  const root = useRef<any>(null)
  const [node, setNode] = useState<any>(null)

  const observer = useRef<any>(null)

  useEffect(() => {
    observer.current = new window.IntersectionObserver(
      (entries: any) => {
        if (entries[0].isIntersecting) {
          if (callback) {
            callback()
          }
        }
      },
      {
        root: root.current,
        rootMargin,
        threshold,
      }
    )

    const { current: currentObserver } = observer

    if (currentObserver) {
      currentObserver.disconnect()

      if (node) currentObserver.observe(node)
    }

    return () => {
      if (currentObserver) {
        currentObserver.disconnect()
      }
    }
  }, [node, root, rootMargin, threshold, callback])

  return { refItem: setNode, refRoot: root }
}
